import React, { useState, useEffect } from 'react';

const CookieConsent: React.FC = () => {
  // Check localStorage synchronously during initialization to prevent flash
  const [showBanner, setShowBanner] = useState(() => {
    const consent = localStorage.getItem('cookieConsent');
    return consent === null; // Only show if no decision has been made
  });

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // If user previously accepted, load Google Analytics
    const consent = localStorage.getItem('cookieConsent');
    if (consent === 'accepted') {
      loadGoogleAnalytics();
    }
    // If declined or no choice, we do nothing (no tracking)
  }, []);

  const loadGoogleAnalytics = () => {
    // Load Google Analytics script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-CWYDB06F6R';
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-CWYDB06F6R');
    `;
    document.head.appendChild(script2);
  };

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    loadGoogleAnalytics();
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#1a365d',
        color: 'white',
        padding: '1.5rem',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        alignItems: 'center',
      }}
    >
      <div style={{ maxWidth: '1200px', width: '100%' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: windowWidth < 768 ? 'column' : 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '1rem',
          }}
        >
          <p style={{ margin: 0, fontSize: '0.95rem', lineHeight: '1.5' }}>
            Vi bruker informasjonskapsler (cookies) for å forbedre din opplevelse og analysere trafikk på nettstedet vårt.
            Ved å klikke "Godta" samtykker du til vår bruk av cookies.{' '}
            <a
              href="/personvern"
              style={{
                color: '#b8860b',
                textDecoration: 'underline',
              }}
            >
              Les mer om personvern
            </a>
          </p>
          <div
            style={{
              display: 'flex',
              flexDirection: windowWidth < 480 ? 'column' : 'row',
              gap: '0.75rem',
              flexShrink: 0,
              width: windowWidth < 480 ? '100%' : 'auto',
            }}
          >
            <button
              onClick={handleDecline}
              style={{
                backgroundColor: 'transparent',
                border: '2px solid white',
                color: 'white',
                padding: '0.625rem 1.5rem',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '0.95rem',
                fontWeight: 600,
                whiteSpace: 'nowrap',
                transition: 'all 0.2s',
                width: windowWidth < 480 ? '100%' : 'auto',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              Avslå
            </button>
            <button
              onClick={handleAccept}
              style={{
                backgroundColor: '#b8860b',
                border: 'none',
                color: 'white',
                padding: '0.625rem 1.5rem',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '0.95rem',
                fontWeight: 600,
                whiteSpace: 'nowrap',
                transition: 'all 0.2s',
                width: windowWidth < 480 ? '100%' : 'auto',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#966f09';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = '#b8860b';
              }}
            >
              Godta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
